import React from 'react';
import PromotionalBanner from './PromotionalBanner';
import { Card, CardContent } from '@/components/ui/card';

interface MarketingBannersProps {
  variant?: 'simple' | 'detailed' | 'dashboard';
}

export const OrganizerVisibilityBanner = () => {
  return (
    <PromotionalBanner
      title="Több regisztráló, nagyobb láthatóság – így segít a platformunk a rendezvényszervezőknek!"
      description="Szeretnéd, hogy rendezvényeid több szakmai érdeklődőt érjenek el? Az egészségügyi szakembereknek szóló eseményeid könnyen elveszhetnek az információs zajban."
      benefits={[
        "Kiemelt eseményeid a főoldalon és az ajánlott listák élén jelennek meg.",
        "Az e-mail értesítésekben a releváns célközönség először a te eseményeidet látja.",
        "Intelligens algoritmusaink azok elé helyezik az eseményeidet, akik valóban érdeklődnek iránta."
      ]}
      ctaText="Próbáld ki kockázatmentesen"
      variant="highlight"
      size="lg"
      backgroundImage="/assets/medihub_gradient_mesh.jpg"
    />
  );
};

export const TargetedReachBanner = () => {
  return (
    <PromotionalBanner
      title="Célzott megjelenés – a megfelelő embereknek"
      benefits={[
        "Az orvosok és egészségügyi szakemberek pontos szakterületük szerint kapnak értesítést.",
        "Nem általános hirdetés, hanem személyre szabott ajánlás.",
        "Közvetlenül az érdeklődők elé kerülnek az eseményeid."
      ]}
      ctaText="Fedezd fel a célzott elérést"
      variant="primary"
      size="md"
    />
  );
};

export const AutomaticMarketingBanner = () => {
  return (
    <PromotionalBanner
      title="Automatikus marketing – kevesebb munka neked"
      benefits={[
        "Nem kell hirdetésekre költened – mi gondoskodunk a célközönség eléréséről.",
        "Intelligens algoritmusaink azok elé helyezik az eseményeidet, akik valóban érdeklődnek iránta.",
        "Időt és pénzt takarítasz meg az automatizált megoldásokkal."
      ]}
      ctaText="Indítsd el az automatizált marketinget"
      variant="secondary"
      size="md"
    />
  );
};

export const RegistrationManagementBanner = () => {
  return (
    <PromotionalBanner
      title="Több regisztráció, kevesebb adminisztráció"
      benefits={[
        "Online regisztrációs rendszer, QR-kódos check-in és jegykezelés.",
        "Egy platformon keresztül kezelheted a résztvevőket.",
        "Értesítéseket küldhetsz a résztvevőknek közvetlenül a rendszerből."
      ]}
      ctaText="Egyszerűsítsd az adminisztrációt"
      variant="primary"
      size="md"
    />
  );
};

export const PricingModelBanner = () => {
  return (
    <PromotionalBanner
      title="Hogyan működik a fizetős modell?"
      benefits={[
        "Ingyenes eseményfeltöltés – minden szervező felviheti eseményeit az alapcsomagban.",
        "Prémium listázás – eseményeid kiemelt helyen jelennek meg. (5 000 – 50 000 Ft / esemény)",
        "Célzott e-mail értesítés – biztosítjuk, hogy a megfelelő emberekhez jusson el az információ.",
        "Jegyeladás és regisztrációs kezelési opciók – jutalékos alapon történik."
      ]}
      ctaText="Nézd meg az árazási opciókat"
      variant="secondary"
      size="md"
    />
  );
};

const MarketingBanners = ({ variant = 'simple' }: MarketingBannersProps) => {
  if (variant === 'dashboard') {
    return (
      <div className="space-y-6">
        <Card>
          <CardContent className="p-0 overflow-hidden">
            <OrganizerVisibilityBanner />
          </CardContent>
        </Card>
      </div>
    );
  }
  
  if (variant === 'detailed') {
    return (
      <div className="space-y-6">
        <OrganizerVisibilityBanner />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
          <TargetedReachBanner />
          <AutomaticMarketingBanner />
          <RegistrationManagementBanner />
          <PricingModelBanner />
        </div>
      </div>
    );
  }
  
  return (
    <div className="space-y-4">
      <OrganizerVisibilityBanner />
    </div>
  );
};

export default MarketingBanners;
